import React, { Component, PropTypes } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import GoogleMapReact from 'google-map-react';
import { Collapse } from 'react-collapse';
import { render } from 'react-dom';
import axios from 'axios';
import classNames from 'classnames';
import moment from 'moment';

// import placeToLink from '../lib/placeToLink';
// import placeToLinkSp from '../lib/placeToLinkSp';

import PlaceModal from '../components/place-modal';

// moment.locale('ja', {
//   weekdays: ["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],
//   weekdaysShort: ["日","月","火","水","木","金","土"],
// });


const breakpoint = 768;
const Marker = () => <div style={{ transform: 'translate(-15px,-48px)' }}><img src="/themes/mba2020/images/map_clusterer/pin.png" /></div>;
// const removeAB = (word) => word.replace(/A|B/g,'');

const convertCampus = (name) => {
  name = name.replace(/日進/g, '日進/長久手');
  return name;
}

class Filter extends React.Component {

  constructor() {
    super();
    this.state = {
      cond: {},
      filter: {},
      results: [],
      places: [],
      value: '',
      done: false,
      open: true,
      selectedUrl: '',
      isModalOpen: false
    }
  }

  async componentDidMount() {
    const getResults = axios.get(`./json/results.json`);
    const getFilter = axios.get(`./json/filter.json`);
    const getPlaces = axios.get(`/json/place.json`);

    const filterItems = await getFilter;
    const resultItems = await getResults;
    const placeItems = await getPlaces;

    resultItems.data.forEach(item => {
      if (item.place) {
        item.place.forEach((place, i, list) => {
          let disabled = false;
          placeItems.data.place.forEach((masterPlace) => {
            if (masterPlace.exam_station_area === place) {
              disabled = true;
            }
          });
          list[i] = { value: place, disabled }
        });
      }
    });

    this.setState({
      results: resultItems.data,
      cond: filterItems.data,
      places: placeItems.data,
      done: true,
    });

    if (location.hash) {
      this.setStateViaHash();
    }
  }

  updateFilter(field) {
    this.setState({
      field: field
    });

  }

  setStateViaHash() {
    let query = location.hash.substr(1);
    const obj = ACMS.Library.parseQuery(query);
    for (var key in obj) {
      this.setFilter(key, obj[key]);
    }
  }

  setHashViaState(filter) {
    let hash = '';
    for (var key in filter) {
      if (filter[key]) {
        hash += `${key}=${filter[key]}&`;
      }
    }
    hash = hash.slice(0, -1);
    location.hash = encodeURI(hash);
  }

  setFilter(key, value, addHash) {
    const filter = this.state.filter;
    const cond = Object.assign({}, this.state.cond);
    cond[key].forEach((item) => {
      if (item.value === value) {
        if (item.selected) {
          item.selected = false;
          value = null;
        } else {
          item.selected = true;
        }
      } else {
        item.selected = false;
      }
    });
    const newFilter = Object.assign({}, filter, { [key]: value });
    this.setState({
      filter: newFilter,
      cond: cond
    });
    if (addHash) {
      this.setHashViaState(newFilter);
    }
  }

  toggleOpen() {
    const open = this.state.open;
    this.setState({
      open: !open
    });
  }

  getResults(exp) {
    const state = this.state;
    const filter = state.filter;
    return state.results ? state.results.filter((item) => {
      for (var i in filter) {
        if (!filter[i]) {
          continue;
        }
        if (i === exp) {
          continue;
        }
        if (typeof item[i] === 'string') {
          if (item[i] !== filter[i]) {
            return false;
          }
        } else if (typeof item[i] === 'object') {
          let flag = false;
          item[i].forEach((str) => {
            const data = typeof str === 'string' ? str : str.value;
            if (data === filter[i]) {
              flag = true;
            }
          });
          if (!flag) {
            return false;
          }
        }
      }
      return true;
    }) : [];
  }

  toggleTagList(items, key) {
    const results = this.getResults(key);
    return items ? items.map((item) => {
      item.active = false;
      results.forEach((result) => {
        if (!result[key]) {
          return;
        }
        if (typeof result[key] === 'string') {
          if (item.value && item.value === result[key]) {
            item.active = true;
          }
        } else if (typeof result[key] === 'object') {
          result[key].forEach((str) => {
            const data = typeof str === 'string' ? str : str.value;
            if (item && data && data === item.value) {
              item.active = true;
            }
          })
        }
      })
      return item;
    }) : [];
  }

  orderByFiscalYear(items) {
    return items ? items.sort((a, b) => {
      const x = (parseInt(a.value) + 12) % 16;
      const y = (parseInt(b.value) + 12) % 16;
      return x - y;
    }) : [];
  }

  jumpToLink(link) {
    if (window.innerWidth <= breakpoint) {
      location.href = link;
    }
  }

  toggleDetail(item) {
    if (window.innerWidth <= breakpoint) {
      return;
    }
    const results = this.state.results;
    item.showDetail = !item.showDetail;
    let index = -1;
    results.forEach((result, i) => {
      if (result.entry_id === item.entry_id) {
        index = i;
      }
    })
    if (index === -1) {
      return;
    }
    this.setState({
      results: [
        ...results.slice(0, index),
        item,
        ...results.slice(index + 1)
      ]
    });
  }

  openPlaceModal(place, event) {
    event.stopPropagation();
    // if(window.innerWidth >= breakpoint) {
    this.setState({
      isModalOpen: true,
      selectedUrl: place
    })
    // } else {
    //   this.state.places.forEach((item) => {
    //     if (item.exam_station_area === place){
    //       location.href = `https://www.google.co.jp/maps/place/${item.exam_station_address}`;
    //     }
    //   })
    // }
  }

  getActiveLength(arr) {
    return arr.filter(item => item && item.active).length;
  }

  render() {
    const state = this.state;
    const cond = state.cond;
    const value = state.value;
    const filter = state.filter;
    const results = this.getResults();
    const done = state.done;
    const open = state.open;
    const isModalOpen = state.isModalOpen;
    const selectedUrl = state.selectedUrl;
    const campus = this.toggleTagList(cond.campus, 'campus');
    const system = this.toggleTagList(cond.system, 'system');
    const subject = this.toggleTagList(cond.subject, 'subject');
    const place = this.toggleTagList(cond.place, 'place');
    const date = this.orderByFiscalYear(this.toggleTagList(cond.date, 'date'));
    const mapPlace = [];
    const center = {
      lat: 0,
      lng: 0
    };

    let placeName = null;

    place.forEach((item) => {
      if (item.selected && item.active) {
        placeName = item.label;
      }
    });

    place.forEach((item) => {
      if (item.label !== 'オンライン' && item.label === placeName && item.lat && item.lng) {
        mapPlace.push(Object.assign({}, item));
      }
    });

    if (mapPlace.length === 1) {
      center.lat = mapPlace[0].lat;
      center.lng = mapPlace[0].lng;
    } else if (mapPlace.length > 1) {
      center.lat = mapPlace.reduce((a, b) => a.lat + b.lat) / mapPlace.length,
        center.lng = mapPlace.reduce((a, b) => a.lng + b.lng) / mapPlace.length
    }


    return (
      <div>

        <div onClick={this.toggleOpen.bind(this)}>
          {open ?
            <h2 className="js-toggle-nucb-head c-toggle__head"><span className="js-toggle-nucb-arrow"><i className="fas fa-chevron-circle-right"></i></span>条件で絞り込む</h2>
            :
            <h2 className="js-toggle-nucb-head c-toggle__head is-closed"><span className="js-toggle-nucb-arrow"><i className="fas fa-chevron-circle-right"></i></span>条件で絞り込む</h2>
          }
        </div>

        <Collapse isOpened={open}>
          {done &&
            <div>
              <div className="tag-filter-wrap">
                <table className="tag-filter">
                  <tbody>
                    <tr>
                      <th>試験月</th>
                      <td>
                        <ul className="tag-filter-list">
                          {date && date.map(item =>
                            <li className={classNames('c-label-primary -label-color-light -filter', { selected: item.selected, disabled: !item.active })} onClick={this.setFilter.bind(this, 'date', item.value, true)}>{item.value}</li>
                          )}
                        </ul>

                      </td>
                    </tr>
                    <tr>
                      <th>募集キャンパス</th>
                      <td>
                        <ul className="tag-filter-list">
                          {campus.map(item =>
                            <li className={classNames('c-label-primary -label-color-light -filter', { selected: item.selected, disabled: !item.active })} onClick={this.setFilter.bind(this, 'campus', item.value, true)}>{convertCampus(item.label)}</li>
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>方式</th>
                      <td>
                        <ul className="tag-filter-list">
                          {system.map(item =>
                            <li className={classNames('c-label-primary -label-color-light -filter', { selected: item.selected, disabled: !item.active })} onClick={this.setFilter.bind(this, 'system', item.value, true)}>{item.label}</li>
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>試験科目</th>
                      <td>
                        <ul className="tag-filter-list">
                          {subject.map(item =>
                            <li className={classNames('c-label-primary -label-color-light -filter', { selected: item.selected, disabled: !item.active })} onClick={this.setFilter.bind(this, 'subject', item.value, true)}>{item.label}</li>
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>試験会場</th>
                      <td>
                        <ul className="tag-filter-list">
                          {_.uniq(place, (item) => item.label).map(item =>
                            <li className={classNames('c-label-primary -label-color-light -filter', { selected: item.selected, disabled: !item.active })} onClick={this.setFilter.bind(this, 'place', item.label, true)}>{item.label}</li>
                          )}
                        </ul>
                      </td>
                    </tr>
                    {mapPlace.length > 0 &&
                      <tr>
                        <td></td>
                        <td>
                          <div className="tag-filter-google-container">
                            <div className="tag-filter-google-wrap">
                              <GoogleMapReact
                                center={center}
                                defaultZoom={14}
                                apiKey="AIzaSyAykkmDFHmJrPNgZpxGiX71D3b0_uZZVO8"
                              >
                                {mapPlace.map(item => <Marker lat={item.lat} lng={item.lng} />)}
                              </GoogleMapReact>
                            </div>
                          </div>
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          }
        </Collapse>
        <div className="p-summary-bg-card -event -admission-schedule">
          <div className="p-summary-bg-card__list">
            {results.map(item => item.title &&
              <VisibilitySensor partialVisibility={true} minTopValue={1} intervalDelay={100}>
                {({ isVisible }) =>
                  <div className={classNames("p-summary-bg-card__item acms-col-12", { 'admission-inview': item.isVisible || isVisible && (item.isVisible = true) })} onClick={this.jumpToLink.bind(this, item.titleUrl)}>
                    <div className="p-summary-bg-card__inner">
                      <header>
                        <div className="admission-title-label">
                          <h2><a href={item.titleUrl}>{item.title}</a>
                            {item.entryAcceptance &&
                              <span className="p-label-event-status -status-on">
                                {item.entryAcceptanceText ?
                                  <span>{item.entryAcceptanceText}</span> :
                                  <span>出願受付中</span>
                                }
                              </span>
                            }
                          </h2>
                          <ul>
                            {item.campus.map(campus => <li className="c-label-primary -label-color-light">{convertCampus(campus)}</li>)}
                            {item.formula.map(formula => <li className="c-label-primary -label-color-light">{formula}</li>)}
                            {item.subject.map(subject => <li className="c-label-primary -label-color-light">{subject}</li>)}
                            {item.examSingleOrMulti && <li className="c-label-primary -label-color-light">{item.examSingleOrMulti}</li>}
                          </ul>
                        </div>
                        <div className="admission-button">
                          <ul className="p-summary-bg-card__button_list">
                            <li><button className={classNames("c-btn-md -color-primary-border", { '-arrow-up': item.showDetail }, { '-arrow-down': !item.showDetail })} onClick={this.toggleDetail.bind(this, item)}>詳細を見る</button></li>

                            {item.netApplication &&
                              <li>
                                {item.netApplicationText ?
                                  <a className="c-btn-md -arrow-right" href={item.netApplicationUrl}>{item.netApplicationText}</a> :
                                  <a className="c-btn-md -arrow-right" href={item.netApplicationUrl}>ネット出願をする</a>
                                }
                              </li>
                            }
                          </ul>
                        </div>
                      </header>
                      {(item.applyPeriod.length >= 2 || item.examDate.length >= 1 || item.exam_result_date) &&
                        <div className="admission-info">
                          {item.applyPeriod.length >= 2 &&
                            <dl className="admission-info-list c-list-definition p-admission-dl-list">
                              <dt>出願期間</dt>
                              <dd>
                                {item.applyPeriod.map(date => date.startText && date.endText && (
                                  <div>
                                    <span className="p-admission-date p-admission-date__small -inline-block">{date.startText}</span>
                                    <span className="p-admission-date -inline-block admission-hyphen">&nbsp;-&nbsp;</span>
                                    <span className="p-admission-date p-admission-date__small -inline-block -inline-block-end">{date.endText}</span>
                                  </div>
                                ))}
                                {item.applyPeriod.map(date => date.startText && !date.endText && (
                                  <div>
                                    <span className="p-admission-date p-admission-date__small -inline-block">{date.startText}</span>
                                  </div>
                                ))}
                                {item.applyPeriod.map(date => moment(date.startDate, 'YYYY-MM-DD').isValid() && moment(date.endDate, 'YYYY-MM-DD').isValid() && !date.startText && !date.endText && (
                                  <div>
                                    <span className="p-admission-date -inline-block">
                                      {moment(date.startDate, 'YYYY-MM-DD').format('M.D')}&nbsp;<span className="admission-week">{moment(date.startDate, 'YYYY-MM-DD').format('ddd')}</span>
                                    </span>

                                    <span className="p-admission-date -inline-block admission-hyphen">&nbsp;-&nbsp;</span>
                                    <span className="p-admission-date -inline-block p-admission-date -inline-block-end">
                                      {moment(date.endDate, 'YYYY-MM-DD').format('M.D')}&nbsp;<span className="admission-week">{moment(date.endDate, 'YYYY-MM-DD').format('ddd')}</span>
                                    </span>
                                  </div>
                                ))}
                                {item.applyPeriod.map(date => moment(date.startDate, 'YYYY-MM-DD').isValid() && !moment(date.endDate, 'YYYY-MM-DD').isValid() && !date.startText && !date.endText && (
                                  <div>
                                    <span className="p-admission-date -inline-block">
                                      {moment(date.startDate, 'YYYY-MM-DD').format('M.D')}&nbsp;<span className="admission-week">{moment(date.startDate, 'YYYY-MM-DD').format('ddd')}</span>
                                    </span>
                                  </div>
                                ))}

                              </dd>
                            </dl>}
                          {(item.examDate.length >= 1 || item.examDateJa.length >= 1) &&
                            <dl className="admission-info-list c-list-definition p-admission-dl-list">
                              <dt>試験日</dt>
                              <dd>
                                {item.examDate.map((date, index) =>
                                  <div>
                                    {item.examDateJa[index] &&
                                      <span className="p-admission-date p-admission-date__small -inline-block">{item.examDateJa[index]}</span>
                                    }
                                    {moment(date, 'YYYY-MM-DD').isValid() && !item.examDateJa[index] &&
                                      <span className="p-admission-date -inline-block">
                                        {moment(date, 'YYYY-MM-DD').format('M/D')}&nbsp;<span className="admission-week">{moment(date, 'YYYY-MM-DD').format('ddd')}</span>
                                      </span>
                                    }
                                    <ul className="p-admission-exam__list">{item.place.slice(index * 10, index * 10 + 10).map((venue, i) => venue &&
                                      <li key={i} className={classNames('p-admission-exam__item', { disabled: !venue.disabled })} onClick={(event) => { this.openPlaceModal(venue.value, event) }}>{venue.value}</li>
                                    )}</ul>
                                  </div>
                                )}
                              </dd>
                            </dl>}
                          {(item.exam_result_dateJa || item.exam_result_date) &&
                            <dl className="admission-info-list c-list-definition p-admission-dl-list">
                              <dt>合格発表</dt>
                              <dd>
                                <div>
                                  {item.exam_result_dateJa &&
                                    <span className="p-admission-date p-admission-date__small -inline-block">{item.exam_result_dateJa}</span>
                                  }
                                  {!item.exam_result_dateJa && item.exam_result_date && moment(item.exam_result_date, 'YYYY-MM-DD').isValid() &&
                                    <span className="p-admission-date -inline-block">
                                      {moment(item.exam_result_date, 'YYYY-MM-DD').format('M.D')}&nbsp;<span className="admission-week">
                                        {moment(item.exam_result_date, 'YYYY-MM-DD').format('ddd')}
                                      </span>
                                    </span>
                                  }
                                </div>
                                {item.exam_result_group.map(result =>
                                  result.exam_result_group_date &&
                                  <div>
                                    {result.exam_result_group_dateJa &&
                                      <span className="p-admission-date p-admission-date__small -inline-block">{result.exam_result_group_dateJa}</span>

                                    }
                                    {moment(result.exam_result_group_date, 'YYYY-MM-DD').isValid() && !result.exam_result_group_dateJa &&
                                      <span className="p-admission-date -inline-block">
                                        {moment(result.exam_result_group_date, 'YYYY-MM-DD').format('M.D')}&nbsp;<span className="admission-week">
                                          {moment(result.exam_result_group_date, 'YYYY-MM-DD').format('ddd')}
                                        </span>
                                      </span>
                                    }
                                  </div>
                                )}
                              </dd>
                            </dl>}
                        </div>
                      }
                      {item.showDetail &&
                        <div className="admission-detail">
                          {item.examAcademic &&
                            <div>
                              <h2 className="c-heading-lg">募集学部</h2>
                              <div className="p-entry-text-unit"><p>{item.examAcademic}</p></div>
                            </div>
                          }
                          {item.examPayment &&
                            <div>
                              <h2 className="c-heading-lg">検定料</h2>
                              <div className="p-entry-text-unit"><p>{item.examPayment}円</p></div>
                            </div>
                          }
                          {item.school_fee_date &&
                            <div>
                              <h2 className="c-heading-lg">学納金締切日</h2>
                              <div className="p-entry-text-unit">
                                <p>
                                  <time className="p-admission-date -inline-block">
                                    {item.school_fee_date &&
                                      moment(item.school_fee_date, 'YYYY-MM-DD').isValid() ?
                                      moment(item.school_fee_date, 'YYYY-MM-DD').format('M.D') :
                                      item.school_fee_date}&nbsp;
                                      {item.school_fee_date &&
                                      moment(item.school_fee_date, 'YYYY-MM-DD').isValid() ?
                                      moment(item.school_fee_date, 'YYYY-MM-DD').format('ddd') :
                                      null}
                                  </time>
                                </p>
                              </div>
                            </div>
                          }
                          {item.entry_examination_subjects &&
                            <div>
                              <h2 className="c-heading-lg">試験科目</h2>
                              <div className="p-entry-text-unit" dangerouslySetInnerHTML={{ __html: item.entry_examination_subjects }}></div>
                            </div>
                          }
                          {item.entry_scoring &&
                            <div>
                              <h2 className="c-heading-lg">配点</h2>
                              <div className="p-entry-text-unit" dangerouslySetInnerHTML={{ __html: item.entry_scoring }}></div>
                            </div>
                          }
                          {item.remarksColumn &&
                            <div>
                              <h2 className="c-heading-lg">備考/出願資格</h2>
                              <div className="p-entry-text-unit" dangerouslySetInnerHTML={{ __html: item.remarksColumn }}></div>
                            </div>
                          }
                          {item.admission_pdf_list.length > 1 &&
                            <ul className="p-admission-pdf">
                              {item.admission_pdf_list.map((pdf) =>
                                pdf.admission_pdf_item_path &&
                                <li className="p-admission-pdf__item">
                                  <a className="p-admission-pdf__link" href={`/archives/${pdf.admission_pdf_item_path}`}>
                                    <img className="p-admission-pdf__img" src="/themes/mba2020/images/fileicon/pdf.svg" width="64" height="64" alt="pdf" />
                                    <span className="p-admission-pdf__caption">{pdf.admission_pdf_caption}</span>
                                  </a>
                                </li>
                              )}
                            </ul>
                          }
                        </div>
                      }
                    </div>

                  </div>}
              </VisibilitySensor>
            )}
          </div>
        </div>
        <PlaceModal url={selectedUrl} open={isModalOpen} onClose={() => { this.setState({ isModalOpen: false, selectedUrl: '' }) }} />
      </div>
    );
  }
}


export default () => {
  $(function () {
    render(
      <Filter />,
      document.getElementById('root')
    );
  });
}
